import type { ReactNode } from "react"
import { cn, Icon, type IconName } from "@nexus/ui"

export interface DrilldownCardBadgeProps {
  icon?: IconName
  children: ReactNode
  className?: string
}

/**
 * Shared "white/90, rounded-[4px], 10px text + icon" overlay chip used for the
 * media-type pill, dup pill, and days-active pill on the redesigned Drilldown
 * grid card. Overlay chips on photographic media are an accepted exception to
 * the "no raw hex" rule (same category as CreativeCard.tsx's existing
 * bg-black/40 badges) — dark-mode variant keeps contrast on the same media.
 */
export function DrilldownCardBadge({ icon, children, className }: DrilldownCardBadgeProps) {
  return (
    <span
      className={cn(
        "flex items-center gap-1 rounded-[4px] bg-white/90 px-1.5 py-0.5 text-[11px] leading-[15px] text-gray-700 dark:bg-black/60 dark:text-gray-200",
        className,
      )}
    >
      {icon ? <Icon name={icon} size="xs" color="inherit" /> : null}
      {children}
    </span>
  )
}
